import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClipLoader from "react-spinners/ClipLoader";
import DatePicker from "react-datepicker";
import { workoutsCompleted, workoutsCompletedByUser, workoutsCompletedByWorkout, planPurchased,  getUsers } from '../../actions';
import "react-datepicker/dist/react-datepicker.css";
import './numbers.css';

class Numbers extends Component {
  initState = {
    users: null,
    workoutsCompleted: null,
    workoutsCompletedByUser: null,
    purchasedPlan: null
  }
  state = {
    date: new Date('11/1/2020'),
    ...this.initState
  }

  componentWillMount = () => {
    this.props.workoutsCompleted(this.state.date);
    this.props.getUsers(this.state.date);
    this.props.workoutsCompletedByUser(this.state.date);
    this.props.planPurchased(this.state.date);

  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.numbersWorkoutsCompleted) {
      this.setState({
        workoutsCompleted: nextProps.numbersWorkoutsCompleted
      })
    }

    if(nextProps.users){
      this.setState({
        users: nextProps.users
      })
    }

    if(nextProps.numbersWorkoutsCompletedByUser){
      this.setState({
        workoutsCompletedByUser: nextProps.numbersWorkoutsCompletedByUser
      })
    }

    if(nextProps.purchasedPlan){
      this.setState({
        purchasedPlan: nextProps.purchasedPlan
      })
    }
  }

  byUserElement = (item, i) => (
    <div key={i} className="inline-workouts-completed">
      <div className="header-workouts-completed"> { item.email || item._id } </div>
      <div className="value-workouts-completed"> { item.count }</div>
    </div>
  )

  planByUser = (item, i) => (
    <div key={i} className="inline-workouts-completed">
      <div className="header-workouts-completed"> { item.email } </div>
      <div className="value-workouts-completed"> { item.count }</div>
    </div>
  )

  renderArray = (items, type) => (
    type === 'user' ?
    items.sort((a,b) => (a.email > b.email) ? 1 : ((b.email > a.email) ? -1 : 0)).map((item, i) => {
      if(!item.email) return null;
      return this.byUserElement(item, i);
    }) :
    Object.keys(items).sort((a,b) => (items[a].email > items[b].email) ? 1 : ((items[b].email > items[a].email) ? -1 : 0)).map((key, i) => {
      return this.planByUser(items[key], i);
    })
  )

  loader = () => (
    <ClipLoader
              size={15}
              color={"#123abc"}
              loading={true}
            />
  )

  countPurchase = () => {
    console.log(this.state.users);
    return this.state.users && this.state.users.normalauths ? this.state.users.normalauths.filter(auth => auth.user && auth.user.purchase).length: 0 ;
  }
  getUsersByDate = (date) => {
    this.setState({
      date,
      ...this.initState
    })

    this.props.workoutsCompleted(date);
    this.props.getUsers(date);
    this.props.workoutsCompletedByUser(date);
    this.props.planPurchased(this.state.date);
  }

  render() {
    return (
      <div className="">
        <DatePicker className="selectDate" selected={this.state.date} onChange={date => this.getUsersByDate(date)} />
        <div className="inline-number-box">
          <div className="number-box">
            <div className="title">
            Sign-ups
            </div>
            <div className="value">
              { 
                this.props.users ? this.props.users.counter : this.loader()
              }
            </div>
          </div>
          <div className="number-box">
            <div className="title">
              Active Plan 
            </div>
            <div className="value">
              { 
                this.state.purchasedPlan ? Object.keys(this.state.purchasedPlan.planByUser).length : this.loader()
              }
            </div>
          </div>
          <div className="number-box">
            <div className="title">
              Started Workouts
            </div>
            <div className="value">
              { 
                this.state.users ? this.state.users.startedWorkoutCounter : this.loader()
              }
            </div>
          </div> 
          <div className="number-box">
            <div className="title">
              Workouts Completed
            </div>
            <div className="value">
              { 
                this.props.numbersWorkoutsCompleted ? this.props.numbersWorkoutsCompleted.count : this.loader()
              }
            </div>
          </div>
          <div className="number-box">
            <div className="title">
              Purchased Plans
            </div>
            <div className="value">
              { 
                this.state.purchasedPlan ? this.state.purchasedPlan.count : this.loader()
              }
            </div>
          </div>
        </div>
        <div className="inline">
        <div className="workouts-completed number-box">
          <div className="title title-workouts-completed">
            Workouts Completed
          </div>
          <div className="value-workouts-completed">
            { 
              this.state.workoutsCompletedByUser ? this.renderArray(this.state.workoutsCompletedByUser, 'user') : this.loader()
            }
          </div>
        </div>
        <div className="workouts-completed number-box">
          <div className="title title-workouts-completed">
            Purchased Plan
          </div>
          <div className="value-workouts-completed">
            { 
              this.state.purchasedPlan ? this.renderArray(this.state.purchasedPlan.planByUser, 'plan') : this.loader()
            }
          </div>
        </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    numbersWorkoutsCompleted: state.numbers.workoutsCompleted,
    numbersWorkoutsCompletedByUser: state.numbers.workoutsCompletedByUser,
    purchasedPlan: state.numbers.planPurchased,
    users: state.user.users
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ workoutsCompleted, workoutsCompletedByUser, 
    workoutsCompletedByWorkout, planPurchased, getUsers},dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Numbers);